import { createStyles, Theme } from '@material-ui/core/styles'

export default (theme: Theme) =>
	createStyles({
		companyRoot: {
			flexDirection: 'column',
			display: 'flex',
			width: '100%',
			maxWidth: '100%',
		},
		flexGrow: {
			flexGrow: 1,
		},
		createCompanyContainer: {
			top: '90px',
			bottom: theme.spacing(6),
			width: '100%',
			height: 'auto',
			maxWidth: '670px',
			padding: '0px 10px',
		},
		formSection: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			marginTop: '30px',
		},
		uploadSection: {
			display: 'flex',
			flexFlow: 'row',
			alignItems: 'center',
		},
		formControl: {
			width: '100%',
		},
		textField: {
			width: '100%',
		},
		input: {
			color: '#000000',
			fontSize: '14px',
		},
		labelText: {
			color: theme.palette.grey[800],
			fontSize: '16px',
			marginTop: 10,
			marginBottom: 10
		},
		selectField: {
			width: '100%',
		},
		roundedBtn: {
			outline: 'none',
			cursor: 'pointer',
			marginRight: '5px',
			fontSize: '11px',
			fontWeight: 500,
			border: '1px solid #e1e1f4',
			color: '#1B1A7C',
			padding: '4px 6px',
			borderRadius: '12px',
		},
		chip: {
			margin: 2,
			'&:hover, &:focus': {
				backgroundColor: '#e1e1f4 !important',
				color: '#1B1A7C',
			},
			fontWeight: 500,
			border: '1px solid #e1e1f4',
		},
		chipActive: {
			background: '#e1e1f4',
			color: '#1B1A7C',
			cursor: 'pointer',
		},
		chipInactive: {
			color: '#1B1A7C',
		},
		activeBtn: {
			background: '#e1e1f4',
		},
		uploadBtn: {
			background: '#a9a9a940',
			width: '60px',
			height: '60px',
		},
		title: {
			color: '#1B1A7C',
			marginLeft: '8px',
			fontSize: '12px',
			fontWeight: 'bold',
		},
		submitSection: {
			display: 'flex',
			alignItems: 'center',
			flexFlow: 'row',
		},
		submitBtn: {
			outline: 'none',
			cursor: 'pointer',
			background: '#1B1A7C',
			fontSize: '14px',
			fontWeight: 'bold',
			color: '#fff',
			borderRadius: '12px',
			marginLeft: 'auto',
			padding: '4px 6px',
			width: '50px',
		},
		infoText: {
			color: '#1B1A7C',
			fontWeight: 'bold',
		},
		displayForm: {
			display: 'block',
		},
		hideForm: {
			display: 'none',
		},
		errorLabel: {
			color: 'red',
		},
		requiredLogoText: {
			marginTop: '5px',
		},
		deleteLogoButton: {
			marginTop: '10px',
			padding: '0px 5px',
			fontSize: '0.75rem',
		},
		labelTextField: {
			color: theme.palette.grey[800],
		},
		labelField: {
			color: theme.palette.grey[800],
		},
		labelFieldError: {
			color: theme.palette.secondary.main,
		},
		requiredField: {
			marginLeft: 5,
			fontSize: 10,
			fontStyle: 'italic',
			color: 'inherit',
		},
	})
